import React from "react";
import PHKLPageContainer from "../../../../components/phkl-page-container/phkl-page-container"; //PHKL Custom
import { PasswordInput } from "../../../../components/password-input/password-input.component";
import { PHKLReEnterPasswordInput } from "../../../../components/password-input/phkl-re-enter-password-input.component";
import { useTranslation } from "react-i18next";
import { useSetPassword } from "./set-password.hook";

export const SetPasswordScreen = () => {
  const { t } = useTranslation();
  //PHKL Custom -s
  const {
    isForgotPassowrd,
    password,
    setPassword,
    reEnterPassword,
    setReEnterPassword,
    onConfirm,
    errorMessages,
    reEnterErrorMessages,
    isValid,
    setIsValid,
    reEnterIsValid,
    setReEnterIsValid,
    isSubmitted,
  } = useSetPassword();
  //PHKL Custom -e

  return (
    <PHKLPageContainer
      title={isForgotPassowrd ? t("Common.reset_password") : t("Common.set_password")}>  {/* PHKL Custom */}
      <div className="flex flex-1 flex-col max-w-md sm:max-w-xl lg:max-w-xl">
        <div className="flex flex-col w-full pb-4 px-8">
          <div className="bg-white w-full rounded-tr-3xl h-10"></div>
          <PasswordInput
            label={t("Recruitment.new_password")}
            value={password}
            onChange={setPassword}
            placeholder={t("Common.please_enter")}
            showError={true}
            errorMessages={errorMessages}
            setIsValid={setIsValid} //PHKL Custom
          />
          <PHKLReEnterPasswordInput
            label={t("Recruitment.re_enter_password")}
            value={reEnterPassword}
            onChange={setReEnterPassword}
            placeholder={t("Common.please_enter")}
            errorMessages={reEnterErrorMessages}
            setIsValid={setReEnterIsValid}
          />
        </div>

        <div className=" w-full bg-white pt-2 pb-7 flex items-center justify-between gap-4 px-8">
          <button
            className="bg-red-500 flex-1 text-white font-semibold py-3 rounded-lg shadow-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-75 disabled:bg-[#CCCCCC] disabled:shadow-none"
            disabled={isSubmitted || !(isValid && reEnterIsValid)} //PHKL Custom
            onClick={onConfirm}>
            {isForgotPassowrd ? t("global.text.confirm") : t("app.button.next") /* PHKL Custom */}
          </button>
        </div>
      </div>
    </PHKLPageContainer>
  );
};
